
function prependChild(parent, child) {
  if (parent.firstChild) {
      parent.insertBefore(child, parent.firstChild);
  } else {
      parent.appendChild(child);
  }
}
function paginationTable(addressDataAll){
      const data = addressDataAll.reverse();
        const itemsPerPage = 50;
      let currentPage = 1;

      // Function to display items for the current page
      function displayData() {
          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const items = document.querySelectorAll('.tr-item');

      for (let i = 0; i < items.length; i++) {
              if (i >= startIndex && i < endIndex) {
                  items[i].classList.add('active');
              } else {
                  items[i].classList.remove('active');
              }
          }
      }
function updatePagination() {
const totalPages = Math.ceil(data.length / itemsPerPage);
const pagination = document.getElementById('pagination');
pagination.innerHTML = '';

if (currentPage > 1) {
  const prevButton = document.createElement('button');
  prevButton.textContent = 'Previous';
prevButton.classList.add('prev');
  prevButton.addEventListener('click', () => {
      currentPage--;
      displayData();
      updatePagination();
  });
  pagination.appendChild(prevButton);
}

const maxVisiblePages = 5;
let startPage = Math.max(1, currentPage - 2);
let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

if (endPage - startPage < maxVisiblePages - 1) {
  startPage = Math.max(1, endPage - maxVisiblePages + 1);
}

for (let i = startPage; i <= endPage; i++) {
  const pageButton = document.createElement('button');
  pageButton.textContent = i;
  if (i === currentPage) {
      pageButton.classList.add('active');
  }
  pageButton.addEventListener('click', () => {
      currentPage = i;
      displayData();
      updatePagination();
  });
  pagination.appendChild(pageButton);
}

if (currentPage < totalPages) {
  const nextButton = document.createElement('button');
  nextButton.textContent = 'Next';
nextButton.classList.add('next');
  nextButton.addEventListener('click', () => {
      currentPage++;
      displayData();
      updatePagination();
  });
  pagination.appendChild(nextButton);
}
$("#address_book tbody tr").click(function(){

$(this).find("input").trigger("click");

})
}

      // Create and append items to the list
      const dataList = document.querySelector('#address_book tbody');
      data.forEach((item, index) => {
          let birthday = "";
          let anniversary = "";
if(item?.birthday || item?.birthday == ''){
birthday = item?.birthday;
}
if(item?.anniversary || item?.anniversary == ''){
anniversary = item?.anniversary;
}
      const li = document.createElement('tr');
          li.classList.add('tr-item');

  li.innerHTML = `
  <td class="actions"><input type="checkbox" name="checked_value" id="id-${item._id}" class="select_data"><label for="id-${item._id}"></label></td>
  <td class="type">${item.type?.toLowerCase() =="return" ? "Sender" : item.type}</td>
  <td class="first-name">${item.firstName}</td>
  <td class="last-name">${item.lastName}</td>
  <td class="business-name">${item.businessName}</td>
  <td class="address-1">${item.address1}</td>
  <td class="address-2">${item.address2}</td>
  <td class="city">${item.city}</td>
  <td class="state">${item.state}</td>
  <td class="zip">${item.zip}</td>
  <td class="country">${item.country}</td>
  <td class="birthday">${birthday}</td>
  <td class="anniversary">${anniversary}</td>
  `;
prependChild(dataList,li)   
// tableOp();
$("#address-book-modal").fadeIn().addClass('active-popup').removeClass('custom-hide');
      });

      // Initial setup
      displayData();
      updatePagination();
}
function firstExampleUpdate() {
var oneval = $("#custom-dropdown-select").text();
var valtwo = $('#messageCustomFontSelectList').find(":selected").val();
if(oneval == "Select Standard Font" && valtwo != "Select Custom Font"){
 $("#example-one-value").css("font-family",valtwo);
 
} else if(oneval != "Select Standard Font" && valtwo == "Select Custom Font") {
$("#example-one-value").css("font-family",oneval);
}
var message = $('#example-one-input').val().replace(/\n/g, '<br/>') || "Enter your custom message text here...";
var signoff = $('#signoff-input').val().replace(/\n/g, '<br/>');
$('#example-one-value').html(
  "<span class='msg-value'>" + message + "<br/><span class='signoff-value'>" + signoff + '</span></span>'
);
if($(".new-card-header").css("display") == "none" && $(".new-card-footer").css("display") == "none" && $(".qr--d img").attr("src") == ""){
$("#example-one-value").height("350px");   
}

if($(".new-card-header").css("display") != "none" && $(".new-card-footer").css("display") != "none" || $(".qr--d img").attr("src") != ""){
$("#example-one-value").height("255px");
    
}

$('#example-one-value').textfill({
  maxFontPixels: 60,
  complete: function() {
      var fontSize = $('#example-one-value').children('span').css('font-size');
      $('#example-one-value').children('span').css('line-height', fontSize);
  }
});

var exampleOneInput = document.getElementById("example-one-input");
var signoffInput = document.getElementById("signoff-input");
var exampleOneCount = document.getElementById("example-one-count");
var signoffCount = document.getElementById("signoff-count");

var exampleOneLength = exampleOneInput.value.length;
var signoffLength = signoffInput.value.length;

var remainingExampleOne = 450 - exampleOneLength;
var remainingSignoff = 50 - signoffLength;

exampleOneCount.textContent = remainingExampleOne + " characters remaining";
signoffCount.textContent = remainingSignoff + " characters remaining";
}
        $(document).ready(function() {
        setTimeout(function(){
            $('[accept=".csv"].upload-input').on('change', function() {
              var fileName = $(this).val().split('\\').pop();
              $('.fileName-added').text(fileName || 'No file chosen');
              $(".get_address_by_id").attr("disabled","true");
            });
            },3000);

          var pathname = window.location.pathname;
          if (pathname.includes("birthday")) {
       
            var newListItem2 = $('<li>1) Download the <a href="https://api.simplynoted.com/docs/bulk-template">Birthday Template.</a></li>');
            $('.first_li_').html(newListItem2);
          }else {
           
             var newListItem = $('<li>1) Download the <a href="https://api.simplynoted.com/docs/bulk-template">Bulk Order Template.</a></li>');
              $('.first_li_').html(newListItem);
          }
    });


$(document).ready(function() {
var selectTag = $('#messageCustomFontSelectList');
var allOptionsBlank = true;
selectTag.find('option').each(function() {
if ($(this).val() !== '') {
allOptionsBlank = false;
return false; // Exit the loop if a non-blank option is found
}
});

// uat-5 start
$("#close-qr").click(function(){
$(".qr-code").hide();
$(".insert-qr-code").prop("checked", false);
$("#qr-link-popup").hide();
});

$("#enter-qr-flat").click(function(){
var getQRposition = $("input[name='getQRposition']:checked").val();
var url = $("#link-qr").val();
if (url == ""){
  alert("Please enter url first!")
}else{
  if (getQRposition == "header") {
    $(".qr-code").css("top", "5px");
    $(".qr-code").css("bottom", "");
  }
  if (getQRposition == "footer") {
    $(".qr-code").css("top", "");
    $(".qr-code").css("bottom", "5px");
  }
$(".check-qr-popup-wrapper").fadeIn();
    $(".check-qr-wrapper").html(`
    <img 
      src="https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${url}" 
      alt="QR" 
    />
  `);
  $(".qr-code").show();

  $("#qr-link-popup").hide();
}
});




$(".change-qr-continue").click(function(){




     $(".insert-qr-code").prop("checked", true);
$(".cardFoldedInsideOptions .qr-add-button,#cardFlatQRoptions .qr-add-button,#cardFlatQRoptionsHeader .qr-add-button").addClass("remove-now");    
$("#open-qr-popup,.open-qr-popup").text("Remove QR Code")

$(".qr-code").html(`<img src="${$(".check-qr-wrapper img").attr("src")}"/>`);
$("#cardFooter").addClass("qr_active");
if(window.customCardType == 'folded5x7'){
if($(".foldCardBtnFront").hasClass('activate') || $(".foldCardBtnBack").hasClass('activate')){

$("#foldedCardButtonInside").trigger("click");
}
}
else{
$(".footer-image-wrapper").hide();
}
$(".check-qr-popup-wrapper").hide();

});
$(".qr-continue").click(function(){
$("#qr-link-popup").show();

$(".check-qr-popup-wrapper").hide();
});
$(".cardFoldedInsideOptions").click(function(){
var isChecked = $(".insert-qr-code").prop("checked");
if (isChecked){
$(".qr-code").hide();
  $("#cardFooter").removeClass("qr_active");
$(".insert-qr-code").prop("checked", false);
      $(".qr-add-button").removeClass("remove-now"); 
 $(".footer-image-wrapper").show();
$("#open-qr-popup").text("Add QR Code")
}else{
$("#enter-qr").show();
$("#enter-qr-flat").hide();
$("#qr-link-popup").show();
}
});
$(".cardFlatQRoptions").click(function(){
const title = $(".open-qr-popup").text();
var isChecked = $(".insert-qr-code").prop("checked");


if (isChecked){
$(".qr-code").hide();
$(".insert-qr-code").prop("checked", false);
$(".open-qr-popup").text("Add QR Code")
$(".footer-image-wrapper").show();
    $("#cardFooter").removeClass("qr_active");
$(" .qr-add-button").removeClass("remove-now"); 
}else{
$("#enter-qr").hide();
$("#enter-qr-flat").show();
$("#qr-link-popup").show();
$("#qr-link-popup").show();
}
});
$("#enter-qr").click(function(){
var getQRposition = $("input[name='getQRposition']:checked").val();
var url = $("#link-qr").val();
if (url == ""){
  alert("Please enter url first!")
}else{
  if (getQRposition == "header") {
    $(".qr-code").css("top", "5px");
    $(".qr-code").css("bottom", "");
  }
  if (getQRposition == "footer") {
    $(".qr-code").css("top", "");
    $(".qr-code").css("bottom", "5px");
  }

$(".check-qr-popup-wrapper").fadeIn();

        $(".check-qr-wrapper").html(`
    <img 
      src="https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${url}" 
      alt="QR" 
    />
  `);
  $(".qr-code").show();

  $("#qr-link-popup").hide();
}
});
// uat-5 end

$("#dropdown-types").on("change", function() {
$("#select-all-button").removeClass('checked_value').text('Select All');
$('.count_value').text('0');
let selectedValue = $(this).val();
if(selectedValue == 'return' || selectedValue == 'Sender' || selectedValue == 'sender'){
selectedValue = `&type=${selectedValue}&type=Sender`
}
if(selectedValue == 'recipient' || selectedValue == 'Recipient'){
selectedValue =  `&type=${selectedValue}&type=Recipient`;
}
let filter = (selectedValue == "" || selectedValue == "all") ? "" : `${selectedValue}`
let customerId = localStorage.getItem("snCustomerId");
$.ajax({
method: "GET",
url: "https://api.simplynoted.com/api/storefront/addresses?customerId=" + customerId + filter
}).
done(function (msg) {
   $("#address_book tbody").html(" ") ;
paginationTable(msg.result)
});

});

$(".get_address_by_id").click(function(){
$("#selected_va_checked").addClass("not-active");  
$("#address-book-new").hide();
$("#delete-multiple-addresses").hide();
$('.count_value').text("0");
$(".select_data").removeClass("checked_value"); //hiteshi
$('#select-all-button').removeClass("select_all_data");
var customerId = localStorage.getItem("snCustomerId");
$.ajax({
method: "GET",
url: "https://api.simplynoted.com/api/storefront/addresses?customerId=" + customerId
}).
done(function (msg) {
if(msg.result == ""){
$(".table-paginaton").hide()
$(".address-search-bar h2").text("No Record Found");
$("#address-book-modal").fadeIn().addClass('active-no-record').addClass('active-popup').removeClass('custom-hide');
}
else{
$("#address_book tbody").html(" ");
$(".table-paginaton").css("display","flex")
$("#address-book-modal").removeClass('active-no-record');
$(".address-search-bar h2").text("ADDRESS BOOK");
}

paginationTable(msg.result)


})
.fail(function()  {
alert("Sorry. Server unavailable. ");
});
});

$(".card-template-modal-body .close-button-custom").click(function(event){
$("#card-template-modal").hide();
});


$(".table-address-drawer-inner").click(function(event){
event.stopPropagation();
});
$('#address_book').delegate('.select_data','click',function() {
if($(this).prop("checked")){
$(this).addClass("checked_value");
} else {
 $(this).removeClass("checked_value");
}
var numItems = $('.checked_value').length;
$('.count_value').text(numItems);
window.bulkQuantity = numItems;
if(numItems > 0){
$('body').addClass('selected_enabled')
$(".selected_va_checked").css("display","block");
$(".selected_va_checked_close").show();
  $("#selected_va_checked").removeClass("not-active");  
$(".yes_vcontuies").show();
} else {
$(".yes_vcontuies").hide();
$('body').removeClass('selected_enabled')
$(".selected_va_checked_close").hide();
$(".selected_va_checked").hide();
  $("#selected_va_checked").addClass("not-active");  
}
});

$(".yes_vcontuies").click(function(){
$("#address-book-modal").hide();
var numItems = $('.checked_value').length;
$('.count_value').text(numItems);
window.bulkQuantity = numItems;
if(numItems > 0){
$('body').addClass('selected_enabled')
$(".selected_va_checked").show();
  $("#selected_va_checked").removeClass("not-active");  
$(".selected_va_checked_close").show();
$(".yes_vcontuies").show();
} else {
$('body').removeClass('selected_enabled')
$(".selected_va_checked_close").hide();
}
});

$(".selected_va_checked_close").click(function(){
$(".table-address-drawer").removeClass('active-popup').fadeOut();
$('body').removeClass('selected_enabled');
$('.count_value').text("0");
$(".selected_value").hide();
$("#selected_va_checked").css("display","none");
  $("#selected_va_checked").addClass("not-active");  
$(".select_data").prop('checked',false);
});
$(".close-btn").click(function() {
$("#address-book-modal").hide();
})
$(".selected_va_checked").click(function(){
var address = [];
$( ".checked_value" ).each(function( index ) {
    address.push(
      {
        "First Name": $(this).parents("tr").find('.first-name').text(), 
        "Last Name": $(this).parents("tr").find('.last-name').text(),
        "Address": $(this).parents("tr").find('.address-1').text(),
        "Address 2": $(this).parents("tr").find('.address-2').text(),
        "City": $(this).parents("tr").find('.city').text(),
        "State/Province": $(this).parents("tr").find('.state').text(),
        "Country": $(this).parents("tr").find('.country').text(),
        "Postal Code":  $(this).parents("tr").find('.zip').text(),
        "Phone": "",
        "Email": "",
        "Company": $(this).parents("tr").find('.business-name').text(),
        "Birthday": $(this).parents("tr").find('.birthday').text(),
        "Anniversay": $(this).parents("tr").find('.anniversary').text()      
      }
    );
});
var settings = {
url: "https://api.simplynoted.com/api/orders/bulk-orders-upload-s3",
method: "POST",
timeout: 0,
headers: {
"Content-Type": "application/json",
Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI2NDNiYjVhOTAwODcwZjFmMjQ3OGRjNjkiLCJ1c2VyIjp7ImVtYWlsIjoiZmFicHJvamVjdG1hbmFnZXJAZ21haWwuY29tIiwic2hvcGlmeUlkIjoiNjIzMjYyMjg5MTExMyIsIl9pZCI6IjY0M2JiNWE5MDA4NzBmMWYyNDc4ZGM2OSIsImZpcnN0X25hbWUiOiJQcmFkZWVwIiwibGFzdF9uYW1lIjoic2luZ2gifSwiaWF0IjoxNjkwNDQwNDY0fQ.5s5g9A2PtZ8Dr5dQZsd0D9wWTT2BzDioqDXzTbIJPko",
Cookie: "connect.sid=s%3AsCSd5SQx6YWpkAeNCoMpskt1xS2Q3Oxy.GYVf206KSQ1bDnuQj1VgSQleLDqSZbk6v99MwuEbX4Q",
},
data: JSON.stringify(address),
};

$.ajax(settings).done(function (response) {
  window.jsonData = address;
  $("#uploadery-container").append('<input type="hidden" name="properties[recipient_upload]" id="recipient_upload" value="' + response.result + '">');
  file = response.result;
  
  $(".shipping-main").show();
  var usCount = 0;
  var nonUsCount = 0;
  
  $.each(address, function (index, item) {
    var country = (item["Country"] || item['"Country"'])?.replace(/"/g, "").trim();
    console.log("count" + country);
    if(country === "USA" || country?.toLowerCase() === "" || country?.toLowerCase() === " " || country?.toLowerCase() === "u.s.a" || country?.toLowerCase() === "u.s" || country?.toLowerCase() === "usa" || country?.toLowerCase() === "us" || country?.toLowerCase() === "america" || country?.toLowerCase() === "united states" || country?.toLowerCase() === "united states of america" || country?.toLowerCase() == undefined){
    usCount++;
    } else {
    nonUsCount++;
    }
  });
  console.log("usCount ", usCount);
  console.log("nonUsCount", nonUsCount);
  window.usCount = usCount;
  window.nonUsCount = nonUsCount;
  moveToAddresses(event);
});
});    
});


$('.check-input').click(function(){
var textareaValue = $("#example-one-input").val();

if (textareaValue === "") {
event.preventDefault();
$('#address-select').hide();
$('#product-customization-block').show();
document.getElementById("example-one-input").focus();
}else{
$('#address-select').show();
$('#product-customization-block').hide();
document.getElementById("example-one-input").focus();
}
});
$('.custom-add-to-cart-button').on('click', function(e){
if(window.isSingle){
$(".shipping-main").hide();
}else{
$(".shipping-main").show();
}

var productId = $(this).attr('data-productId');
//alert(productId);
var data = {
"updates": {}
};
data.updates[productId] = 0;
if(window.location.href.includes('editdata')){
jQuery.ajax({
type: 'POST',
url: '/cart/update.js',
data: data,
dataType: 'json',
success: function(cart) {

  console.log('Cart updated successfully:', cart);
},
error: function(XMLHttpRequest, textStatus) {

  console.error('Error updating cart:', textStatus);
}
});
}
});

function callbackHandler(json_data) {
window.currentProductData = json_data;
}




$('#example-one-input').keyup(firstExampleUpdate);
$('#signoff-input').keyup(firstExampleUpdate);
$('#example-one-input').click(firstExampleUpdate);
firstExampleUpdate();
// trigger on font selection
$('.font-selection').click(function () {
firstExampleUpdate()
})


